export default __webpack_public_path__ + "static/media/basketball-pop3.ad2bf423.png";